export function getManualCache() {
    return caches.open("novorender-explorer-runtime-manual");
}
